import { isFinite, vn, add } from 'vend-number'
import { ApiPriceBookProduct } from '@vend/types'
import { LineItem } from '../models/line-item'

/**
 * Filter all applicable price book products by conditions.
 *
 * @method filterPriceBookProducts
 */
export const filterPriceBookProducts = (
  lineItems: LineItem[],
  lineItem: LineItem,
  priceBookProducts: ApiPriceBookProduct[]
) => {
  // Get the current total quantity for lineItems with matching product id
  const totalLineItemQty = getTotalQuantityForMatchingLineItems(
    lineItems,
    lineItem.product.id
  )

  return priceBookProducts.filter((priceBookProduct: ApiPriceBookProduct) => {
    return withinQuantityLimits(totalLineItemQty, priceBookProduct)
  })
}

/**
 * Iterates over the collection of lineItems and sums up the total quantity for all matching products.
 *
 * @method getTotalQuantityForMatchingLineItems
 */
export const getTotalQuantityForMatchingLineItems = (
  lineItems: LineItem[],
  productId: string
) => {
  return lineItems.reduce((total, lineItem) => {
    const shouldBeIgnored =
      lineItem.adjusted || lineItem.isReturn || lineItem.confirmed

    return lineItem.product.id === productId && !shouldBeIgnored
      ? add(total, lineItem.quantity)
      : total
  }, 0)
}

/**
 * Evaluates if the provided quantity is within quantity limits of the provided price book product.
 *
 * @method withinQuantityLimits
 */
export const withinQuantityLimits = (
  lineItemQuantity: number,
  priceBookProduct: ApiPriceBookProduct
) => {
  const min = priceBookProduct.min_units
  const max = priceBookProduct.max_units
  const moreThanMin =
    min === null || !isFinite(min) || vn(lineItemQuantity).gte(min)
  const lessThanMax =
    max === null || !isFinite(max) || vn(lineItemQuantity).lte(max)

  return moreThanMin && lessThanMax
}
